import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBreadcrumbs, useUser } from '../hooks';
import { addCommas, bindClick, bindFormChange } from '../SiteUtil';
import { Header, Table, Groupper, Icon, Modal, Button, Toast, Message, Toolbar, Input } from 'react-frontier';
import { Dropdown } from 'semantic-ui-react';
import { EventPayout, WorkerPayout, SetLoading } from '../SiteClasses';
import UserAccess from '../UserAccess';
import { useParams, Link } from 'react-router-dom';
import { PayoutWorkersModal, DownloadPayoutModal } from '../components';
import classNames from 'classnames';
import moment from 'moment';
import API from '../API';

interface PayoutViewProps{
   
}

enum Modals{
	INFO = 1,
	PAID = 2,
	CANCEL = 3,
	PAID_ALL = 4,
	CANCEL_ALL = 5,
	DOWNLOAD_PAYOUT = 6,
	EDIT = 7,
	UNPAID_ALL = 8,
	UNPAID = 9
}

var PayoutView = (props: PayoutViewProps)=>{
   var params = useParams<{ pid: string }>();
	var { hasAccess, user } = useUser();
   var { t } = useTranslation();
   var { setTitle } = useBreadcrumbs();
   var [loadError, setLoadError] = useState<string>(null);
   var [payoutData, setPayoutData] = useState<EventPayout>(null);
	var [shownModal, setShownModal] = useState<number>(null);
	var [selectedPayment, setSelectedPayment] = useState<WorkerPayout>(null);
	var [modalPrompts, setModalPrompts] = useState<string[]>([]);

   useEffect(()=>{
      setTitle('Liquidación #'+parseInt(params.pid));
      API.getPayout(parseInt(params.pid)).then(res=>{
         if(res.error) setLoadError(res.message);
         setPayoutData(res.data);
      }).catch(err=>{
         setLoadError('Hubo un error cargando la liquidación (LCL-1)');
      })
   }, []);

	var paid = (setLoading: SetLoading)=>{
		setLoading(true);
		API.paidPayment(payoutData.payout_id, [selectedPayment.worker_id], true).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			Toast.success('Pago realizado!');
			var p = {...payoutData};
			var i = p.payouts.findIndex(w => w.worker_id === selectedPayment.worker_id);
			p.payouts[i].paid = true;
			p.paid_amount += selectedPayment.amount;
			setPayoutData(p);
			setShownModal(null);
			setSelectedPayment(null);
		}).catch(err=>{
			setModalPrompts(['Hubo un error inesperado realizando el pago. (LCL-1)']);
		}).finally(()=>{	
			setLoading(false);
		})
	}

	var unpaid = (setLoading: SetLoading)=>{
		setLoading(true);
		API.paidPayment(payoutData.payout_id, [selectedPayment.worker_id], false).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			Toast.success('Pago marcado como no pagado!');
			var p = {...payoutData};
			var i = p.payouts.findIndex(w => w.worker_id === selectedPayment.worker_id);
			p.payouts[i].paid = false;
			p.paid_amount -= selectedPayment.amount;
			setPayoutData(p);
			setShownModal(null);
			setSelectedPayment(null);
		}).catch(err=>{
			setModalPrompts(['Hubo un error inesperado marcando el pago como no pagado. (LCL-2)']);
		}).finally(()=>{	
			setLoading(false);
		})
	}

	var cancel = (setLoading: SetLoading)=>{
		setLoading(true);
		API.cancelPayment(payoutData.payout_id, [selectedPayment.worker_id]).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			Toast.success('Pago cancelado!');
			var p = {...payoutData};
			var i = p.payouts.findIndex(w => w.worker_id === selectedPayment.worker_id);
			p.payouts[i].cancelled = true;
			p.total_amount -= selectedPayment.amount;
			setPayoutData(p);
			setShownModal(null);
			setSelectedPayment(null);
		}).catch(err=>{
			setModalPrompts(['Hubo un error inesperado cancelando el pago. (LCL-1)']);
		}).finally(()=>{	
			setLoading(false);
		})
	}

	var edit = (setLoading: SetLoading)=>{
			setLoading(true);
			API.editPayment(payoutData.payout_id, selectedPayment.worker_id, selectedPayment.amount, selectedPayment.comment).then(res=>{
				if(res.error) return setModalPrompts([res.message]);
				Toast.success('Pago modificado!');

				var p = {...payoutData};
				var i = p.payouts.findIndex(w => w.worker_id === selectedPayment.worker_id);
				p.payouts[i] = selectedPayment;
				p.total_amount = p.payouts.filter(w => !w.cancelled).reduce((sum, w) => sum + w.amount, 0);
				setPayoutData(p);
				setShownModal(null);
				setSelectedPayment(null);
			}).catch(err=>{
				setModalPrompts(['Hubo un error inesperado editando el pago. (LCL-1)']);
			}).finally(()=>{
				setLoading(false);
			})
	}

	var onMultiplePaid = (ids: number []) =>{
		setPayoutData(prev => {
		var totalPaid = prev.payouts
			.filter(w => ids.includes(w.worker_id))
			.reduce((sum, w) => sum + w.amount, 0);
			return {
				...prev,
				paid_amount: (prev.paid_amount || 0) + totalPaid,
				payouts: prev.payouts.map(w => 
					ids.includes(w.worker_id) 
						? { ...w, paid: true }
						: w
				),
			};
		});
		setShownModal(null);
	}

	var onMultipleCancel = (ids: number []) =>{
		setPayoutData(prev => {
		var totalCancelled = prev.payouts
			.filter(w => ids.includes(w.worker_id))
			.reduce((sum, w) => sum + w.amount, 0);
			return {
				...prev,
				total_amount: prev.total_amount - totalCancelled,
				payouts: prev.payouts.map(w => 
					ids.includes(w.worker_id) 
						? { ...w, cancelled: true }
						: w
				),
			};
		});
		setShownModal(null);
	}

	var onMultipleUnpaid = (ids: number []) =>{
		setPayoutData(prev => {
		var totalUnpaid = prev.payouts
			.filter(w => ids.includes(w.worker_id))
			.reduce((sum, w) => sum + w.amount, 0);
			return {
				...prev,
				paid_amount: (prev.paid_amount || 0) - totalUnpaid,
				payouts: prev.payouts.map(w => 
					ids.includes(w.worker_id) 
						? { ...w, paid: false }
						: w
				),
			};
		});
		setShownModal(null);
	}

   if(loadError) { return <Header text='Error' subtext={loadError} />};
   if(!payoutData) { return <Header text='Cargando datos' loading/> };

	var onFormChange = bindFormChange(selectedPayment, setSelectedPayment);

   return <div>
		<Groupper
			title={'Información de liquidación'}
			width={500}
			style={{ marginTop: 15 }}
		>
			<Toolbar>
				<Toolbar.Item text='Descargar STP' iconName='file-download' onClick={bindClick(setShownModal, Modals.DOWNLOAD_PAYOUT)}/>
			</Toolbar>
			<Table fitted details className='last' style={{ borderBottomLeftRadius: 12, borderBottomRightRadius: 12 }}>
				<Table.Row data={['ID', payoutData.payout_id]}/>
				<Table.Row data={['Evento', <>
					{payoutData.event_name}	
					<Link target='_blank' className='normal' style={{ color: 'black'}} to={`/events/${payoutData.date_id}`}>
						<Icon name='external-link' style={{ marginLeft: 5 }} />
					</Link>
				</>]}/>
				<Table.Row data={['Creado', moment.unix(payoutData.date_created).format('DD/MMM/YY HH:mm')]}/>
				<Table.Row data={['Creador', payoutData.user_creator_name]}/>
			<Table.Row data={['Pagado', '$' + addCommas(payoutData.paid_amount)]}/>
			<Table.Row data={['Total', '$' + addCommas(payoutData.total_amount)]}/>
			<Table.Row data={['Estatus', (
				<div className={classNames("fr label", {
					green: payoutData.total_amount > 0 && payoutData.paid_amount >= payoutData.total_amount,
					yellow: payoutData.total_amount > 0 && payoutData.paid_amount < payoutData.total_amount,
					red: payoutData.total_amount === 0
				})}>
					{payoutData.total_amount === 0 ? 'Cancelado' : payoutData.paid_amount >= payoutData.total_amount ? 'Pagado' : 'No pagado'}
				</div>
			)]}/>
		</Table>
		</Groupper>
		<Table
			fitted
			striped
			title='Pagos'
			headers={['ID', 'Nombre', 'Puesto', 'RFC', 'Creado', 'Comentario', 'Total', 'Estatus', <Icon name='wrench' />]}
			button={(payoutData.payouts.some(p => !p.paid && !p.cancelled) || payoutData.payouts.some(p => p.paid && !p.cancelled)) ? (
				<Dropdown icon={null} pointing direction='left' trigger={(
					<Button text='Opciones' color='black' iconRight='caret-down' iconRightStyle={{ marginRight: 0, marginLeft: 5 }} size='small'/>
				)}>
					<Dropdown.Menu>
						{hasAccess(UserAccess.ACCOUNTING.PAID_PAYOUT) && payoutData.payouts.some(p => !p.paid && !p.cancelled) ? (
							<Dropdown.Item text={'Pagar todos'} icon={'money bill'} onClick={bindClick(setShownModal, Modals.PAID_ALL)} />
						) : null}
						{hasAccess(UserAccess.ACCOUNTING.PAID_PAYOUT) && payoutData.payouts.some(p => p.paid && !p.cancelled) ? (
							<Dropdown.Item text={'Marcar no pagados'} icon={'undo'} onClick={bindClick(setShownModal, Modals.UNPAID_ALL)} />
						) : null}
						{hasAccess(UserAccess.ACCOUNTING.CANCEL_PAYOUT) && payoutData.payouts.some(p => !p.paid && !p.cancelled) ? (
							<Dropdown.Item text={'Cancelar todos'} icon={'ban'} onClick={bindClick(setShownModal, Modals.CANCEL_ALL)} />
						) : null}
					</Dropdown.Menu>
				</Dropdown>
			) : null}
			style={{ maxWidth: 900, margin: 'auto', marginTop: 20 }}
		>
			{payoutData?.payouts.length !== 0 ? (
				payoutData?.payouts.map(p => (
					<Table.Row
						key={p.worker_id}
						collapsingIndexes={[0, 1, 2, 3, 4, 6, 7, 8]}
						centeredIndexes={[3, 5]}
						data={[
							p.worker_id,
							p.worker_name,
							p.title_name ? p.title_name : 'Otro',
							p.rfc ? <Icon name='check' color='green'/> : <Icon name='close' color='red'/>,
							moment.unix(p.date_created).format('DD/MM/YY HH:mm'),
							p.comment || <Icon name='minus'/>,
							'$'+addCommas(p.amount),
							<div className={classNames("fr label", {
								green: p.paid && !p.cancelled,
								yellow: !p.paid && !p.cancelled,
								red: p.cancelled
							})}>
								{p.cancelled ? 'Cancelado' : p.paid ? 'Pagado' : 'No pagado'}
							</div>,
							<Dropdown icon={(
								<div className="fr label" style={{ padding: '3px 10px' }}>
									<Icon name='ellipsis' style={{ margin: 0 }} />
								</div>
								)} className='icon'>
									<Dropdown.Menu>
										<Dropdown.Item onClick={()=> { setSelectedPayment(p); setShownModal(Modals.INFO) }}>
											<Icon name="eye" style={{ marginRight: 3 }} /> Info 
										</Dropdown.Item>
										{!p.cancelled && !p.paid && hasAccess(UserAccess.ACCOUNTING.EDIT_PAYOUT) ? (
											<Dropdown.Item onClick={()=> { setSelectedPayment(p); setShownModal(Modals.EDIT) }}>
												<Icon name='pen' style={{ marginRight: 3 }} /> Editar 
											</Dropdown.Item>
										) : null}
										{!p.cancelled && !p.paid && hasAccess(UserAccess.ACCOUNTING.PAID_PAYOUT) ? (
											<Dropdown.Item onClick={()=> { setSelectedPayment(p); setShownModal(Modals.PAID) }}>
												<Icon name='money-bill' style={{ marginRight: 3 }} /> Pagar 
											</Dropdown.Item>
										) : null}
										{!p.cancelled && p.paid && hasAccess(UserAccess.ACCOUNTING.PAID_PAYOUT) ? (
											<Dropdown.Item onClick={()=> { setSelectedPayment(p); setShownModal(Modals.UNPAID) }}>
												<Icon name='undo' style={{ marginRight: 3 }} /> Marcar no pagado 
											</Dropdown.Item>
										) : null}
										{!p.cancelled && !p.paid && hasAccess(UserAccess.ACCOUNTING.CANCEL_PAYOUT) ? (
											<Dropdown.Item onClick={()=> { setSelectedPayment(p); setShownModal(Modals.CANCEL) }}>
												<Icon name='close' style={{ marginRight: 3 }} /> Cancelar 
											</Dropdown.Item>
										) : null}
									</Dropdown.Menu>
							</Dropdown>				
						]}
					/>
				))
			) : (
				<Table.Cell row className='empty' colSpan={9}>
					No se encontraron registros
				</Table.Cell>
			)}
		</Table>
		<Modal open={shownModal === Modals.INFO} size='tiny' onClose={bindClick(setShownModal, null)}>
			<Modal.Header>Información de pago</Modal.Header>
			{selectedPayment &&<Modal.Content style={{ paddingBottom: 0 }}>
				<Table
					striped
					details
					fitted
					data={[
						['ID', selectedPayment.worker_id],
						['Nombre', selectedPayment.worker_name],
						['Puesto', selectedPayment.title_name],
						['Código postal', selectedPayment.zipcode],
						['Creado', moment.unix(selectedPayment.date_created).format('DD/MM/YY HH:mm')],
						['Creador', selectedPayment.user_creator_name],
						['Total', '$'+ addCommas(selectedPayment.amount)],
						...(selectedPayment.paid ? [['Pago', selectedPayment.user_paid_name]] : []),
						...(selectedPayment.paid ? [['Pagado', moment.unix(selectedPayment.date_paid).format('DD/MM/YY HH:mm')]] : []),
						['Estatus', <div className={classNames("fr label", {
							green: selectedPayment.paid && !selectedPayment.cancelled,
							yellow: !selectedPayment.paid && !selectedPayment.cancelled,
							red: selectedPayment.cancelled
						})}>
							{selectedPayment.cancelled ? 'Cancelado' : selectedPayment.paid ? 'Pagado' : 'No pagado'}
						</div>],
						null,
						...(
							selectedPayment.card_number || selectedPayment.clabe
								? [
									[
										'Tipo de cuenta',
										selectedPayment.card_number
											? <><Icon name='credit-card'/> Tarjeta bancaria</>
											: <><Icon name='landmark'/> Transferencia bancaria (SPEI)</>
									],
									[
										'Banco',
										<>
											{selectedPayment.bank}
											<div className="meta">P: {selectedPayment.bank_participant}</div>
										</>
									],
									[
										selectedPayment.card_number ? 'Tarjeta Bancaria' : 'CLABE',
										selectedPayment.card_number ? selectedPayment.card_number : selectedPayment.clabe
									],
									['RFC', selectedPayment.rfc]
								]
								: []
						)
					]}
				/>
			</Modal.Content>}
			<Modal.Actions>
				<Button basic text='Cerrar' onClick={bindClick(setShownModal, null)} />
			</Modal.Actions>
		</Modal>
		<Modal open={shownModal===Modals.PAID} onClose={bindClick(setShownModal)} size='tiny'>
			<Modal.Header>¿Marcar como pagado?</Modal.Header>
			{selectedPayment && <Modal.Content>
				<Header text='¿Marcar como pagado?'/>
				<Table 
					details
					striped
					data={[
						['ID', selectedPayment.worker_id],
						['Nombre', selectedPayment.worker_name],
						['Puesto', selectedPayment.title_name],
						['Monto', '$' + addCommas(selectedPayment.amount)],
					]}
				/>
				<Message type="error" list={modalPrompts} />
			</Modal.Content>}
			<Modal.Actions>
				<Button text='Cerrar' basic onClick={bindClick(setShownModal, null)} />
				<Button text='Guardar' color='black' onClick={paid}/>
			</Modal.Actions>
		</Modal>
		<Modal open={shownModal===Modals.UNPAID} onClose={bindClick(setShownModal)} size='tiny'>
			<Modal.Header>¿Marcar como no pagado?</Modal.Header>
			{selectedPayment && <Modal.Content>
				<Header text='¿Marcar como no pagado?'/>
				<Table 
					details
					striped
					data={[
						['ID', selectedPayment.worker_id],
						['Nombre', selectedPayment.worker_name],
						['Puesto', selectedPayment.title_name],
						['Monto', '$' + addCommas(selectedPayment.amount)],
					]}
				/>
				<Message type="error" list={modalPrompts} />
			</Modal.Content>}
			<Modal.Actions>
				<Button text='Cerrar' basic onClick={bindClick(setShownModal, null)} />
				<Button text='Guardar' color='black' onClick={unpaid}/>
			</Modal.Actions>
		</Modal>
		<Modal open={shownModal===Modals.CANCEL} onClose={bindClick(setShownModal)} size='tiny'>
			<Modal.Header>¿Cancelar pago?</Modal.Header>
			{selectedPayment && <Modal.Content>
				<Header text='¿Marcar pago como cancelado?'/>
				<Table 
					details
					striped
					data={[
						['ID', selectedPayment.worker_id],
						['Nombre', selectedPayment.worker_name],
						['Puesto', selectedPayment.title_name],
						['Monto', '$' + addCommas(selectedPayment.amount)],
					]}
				/>
				<Message type="error" list={modalPrompts} />
			</Modal.Content>}
			<Modal.Actions>
				<Button text='Cerrar' basic onClick={bindClick(setShownModal, null)} />
				<Button text='Cancelar' color='red' onClick={cancel}/>
			</Modal.Actions>
		</Modal>
		<Modal open={shownModal===Modals.EDIT} onClose={bindClick(setShownModal)} size='tiny'> 
			<Modal.Header>Editar pago</Modal.Header>
			{selectedPayment && <Modal.Content>
				<Input label='Monto' value={selectedPayment.amount} onChange={onFormChange('amount')} />
				<Input label='Comentario' textarea value={selectedPayment.comment} onChange={onFormChange('comment')}/>
				<Message type="error" list={modalPrompts} />
			</Modal.Content>}
			<Modal.Actions>
				<Button text='Cancelar' basic onClick={bindClick(setShownModal, null)} />
				<Button text='Guardar' color='black' onClick={edit}/>
			</Modal.Actions>
		</Modal>
		<PayoutWorkersModal
			open={shownModal === Modals.PAID_ALL || shownModal === Modals.CANCEL_ALL || shownModal === Modals.UNPAID_ALL}
			onClose={bindClick(setShownModal, null)}
			payout_id={payoutData.payout_id}
			paid={shownModal === Modals.PAID_ALL}
			unpaid={shownModal === Modals.UNPAID_ALL}
			cancel={shownModal === Modals.CANCEL_ALL}
			onPaid={(ids) => onMultiplePaid(ids)}
			onUnpaid={(ids) => onMultipleUnpaid(ids)}
			onCancel={(ids) => onMultipleCancel(ids)}
		/>
		<DownloadPayoutModal
			open={shownModal === Modals.DOWNLOAD_PAYOUT}
			onClose={bindClick(setShownModal, null)}
			payouts={[payoutData]}
			onComplete={null}
		/>
   </div>
}

export default PayoutView;